import DynamicProductCard from "@elements/dynamicProductCard/dynamicProductCard";
import { IRelatedProductInput } from "@types";

interface RelatedProductProps {
  data?: IRelatedProductInput
  sourceSlug?: string
}

const RelatedProduct: React.FC<RelatedProductProps> = ({ data, sourceSlug }) => {
  return (data ? <div className="w-full mt-10">
    <p className=" md:text-xl sm:text-base text-base font-extrabold text-[#333] mb-3">
      {data.title}
    </p>
    <p className=" md:text-base sm:text-sm text-sm font-light text-[#999] mb-3">
      {data.subtitle}
    </p>
    <div className=" flex flex-wrap  w-full  lmx:justify-start  justify-center">
      {data.items.map((product) => (
        <div className="w-1/2 max-w-[190px] md:p-1 p-1" key={product.default_sku_id}>
          <DynamicProductCard product={product} source="product_details" sourceEntity={"product"} sourceSlug={sourceSlug || ""} section={"Related Products"} sectionEntity="" sectionSlug={""} />
        </div>
      ))}
    </div>
  </div> : null);
}

export default RelatedProduct;